import {
  IDataAttributeMap,
  mapWithDataPrefix,
  ResponsiveTypography,
  ResponsiveTypographyVariant,
  TooltipPosition,
  withTheme,
} from '@se-admin/falcon';
import { i18n } from '@secret-escapes/i18n';
import * as React from 'react';
import { TranslationsContext } from '../../../common/contexts';
import { IDiscountBadge } from '../DiscountBadge.interfaces';
import { DiscountBadgeTooltip } from '../DiscountBadgeTooltip';
import {
  DiscountPriceStyle,
  TextWrapper,
  TooltipStyle,
} from './../_Shared/discountBadgeShared.styles';
import { DiscountBadgeContainer } from './discountBadgeRegular.styles';

/**
 * A discount badge presented on sale card, can have two variands, depends on location on a sale card
 */
const DiscountBadgeRegular: React.FunctionComponent<Partial<IDiscountBadge>> = props => {
  const { showTooltip, discountPrice, theme, discountTooltip, dataAttributes } = props;

  const dataAttr: IDataAttributeMap = mapWithDataPrefix(dataAttributes);

  return (
    <TranslationsContext.Consumer>
      {({ translations }) => (
        <TextWrapper {...dataAttr}>
          <DiscountBadgeContainer>
            <ResponsiveTypography
              variant={ResponsiveTypographyVariant.micro}
              color={theme.color.black}
            >
              {i18n('common.upTo.text', [], translations)}
            </ResponsiveTypography>
            <DiscountPriceStyle {...props}>
              <ResponsiveTypography
                variant={ResponsiveTypographyVariant.t4SansBold}
                allowDangerousRender={true}
                color={theme.color.primary}
              >
                {discountPrice}
              </ResponsiveTypography>

              {showTooltip && (
                <TooltipStyle>
                  <DiscountBadgeTooltip
                    position={TooltipPosition.bottomRight}
                    discountTooltip={discountTooltip}
                  />
                </TooltipStyle>
              )}
            </DiscountPriceStyle>
          </DiscountBadgeContainer>
        </TextWrapper>
      )}
    </TranslationsContext.Consumer>
  );
};

export default withTheme(DiscountBadgeRegular);
